const Backbone = require('backbone');
const _ = require('underscore');
const dustjs = require('dustjs');
require('store/global/components/panel/_panel.dust');
require('store/global/pages/products/_related_categories.dust');
const _relatedCategoriesDust = require('store/global/pages/products/_related_categories_panel.dust');
module.exports = Backbone.View.extend({
	initialize: function() {
		var self = this,
			categoryId = window.dataLayer.categoryIds ? window.dataLayer.categoryIds.split(',')[1] : undefined,
			url = window.BCOM.apiPathPrefix;

		if (url && categoryId) {
			url = `${url}/products/relatedCategories?categoryid=${categoryId}`;
			$.ajax({
				cache: false,
				url: url,
				dataType: 'json',
				success: self.render
			});
		}
	},

	render: function(categories) {
		var self = this;

		if (!self.$relatedCategories) {
			self.$relatedCategories = $('.js-related-categories');
		}
		categories = _.sortBy(categories, function(category) {
			return category.index;
		});
		categories = categories.slice(0, 7);

		dustjs.render(
			_relatedCategoriesDust,
			{
				categories: categories,
				isNiche: window.BCOM.theme.isNiche,
				isClient: true,
				manufacturer: window.dataLayer.manufacturer
			},
			function(err, out) {
				self.$relatedCategories.html(out + self.$relatedCategories.html());
			}
		);
	}
});
